<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-form-group :label="$t('student_application_date')">
                    <b-input-group>
                        <div class="label-as-input">{{  isNotNullValue(formData.student_application_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('is_take_application_date')">
                    <b-input-group>
                        <div class="label-as-input">{{  isNotNullValue(formData.is_take_application_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('is_approve_date')">
                    <b-input-group>
                        <div class="label-as-input">{{  isNotNullValue(formData.is_approve_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('student_approve_date')">
                    <b-input-group>
                        <div class="label-as-input">{{  isNotNullValue(formData.student_approve_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('transfer_committee_coordinator')">
                    <b-input-group>
                        <div class="label-as-input">{{  isNotNullValue(formData.iks_approve_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>

    export default {
        props: {
            formData: {
                type: Object,
                default: () => ({}),
            },
        },
        data() {
            return {
            }
        },
    }
</script>
